export default "__VITE_ASSET__BOwMxTw0__"